module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/aaatenBC.72da5da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/aaatenBC.jpg
// module id = baPh
// module chunks = 0